import {
  addProducerAssistant,
  changePassword,
  getUserOktaUserId,
  getUserProfile,
  lookupAppUrl,
  lookupProducer,
  lookupUlookupUserser,
  lookupRegistrationKey,
  lookupSignUrl,
  registerProducer,
  registerSecondProducer,
  validateProducer, lookupUserProfile,lookupUser
} from '../service'

export default {
    namespaced: true,
    state: {
      showRegistrationForm: false,
      ShowCompletedForm: false,
      producerNum: null,
      partyTypeCode: null,
      lookupError: null,
      validateError: null,
      dobOrTaxId: null,
      producerFirstName:'',
      producerLastName:'',
      producerEmail:'',
      registrationStatus:'',
      response:'',
      userResponse:'',
      userProfileResponse:'',
      secondProducerResponse:'',
      producerAssistanceResponse:'',
      setAddProducerAssistantResponse:'',
      permissionId:'',
      UserOktaUserResponse:'',
      signInLink:'',
      userProfile:'',
      appUrl:''
    },

    getters: {

    },

    mutations: {
      setShowRegistrationForm (state, shouldShow) {
        state.showRegistrationForm = shouldShow
      },
      setShowCompletedForm (state, shouldShow) {
        state.ShowCompletedForm = shouldShow
      },
      setProducerFirstName(state,producerFirstName){
        state.producerFirstName = producerFirstName
      },
      setproducerLastName(state,producerLastName){
        state.producerLastName = producerLastName
      },
      setregistrationStatus(state,registrationStatus){
        state.registrationStatus = registrationStatus
      },
      setproducerEmail(state,producerEmail){
        state.producerEmail = producerEmail
      },
      setPartyTypeCode (state, code) {
        state.partyTypeCode = code
      },
      setLookupError (state, err) {
        state.lookupError = err
      },
      setValidateError (state, err) {
        state.validateError = err
      },
      setProducerNum (state, producerNum) {
        state.producerNum = producerNum
      },
      setDobOrTaxId (state, dobOrTaxId) {
        state.dobOrTaxId = dobOrTaxId
      },
      setPermissionId(state, permissionId) {
        state.permissionId = permissionId
      },
      setResponse(state, payload){
        state.response=payload
      },
      setUserResponse(state, payload){
        state.userResponse=payload
      },
      setSecondProducerResponse(state, payload){
        state.secondProducerResponse=payload
      },
      setProducerAssistanceResponse(state, payload){
        state.producerAssistanceResponse=payload
      },
      setUserOktaUserResponse(state, payload){
        state.UserOktaUserResponse=payload
      },
      setSignInLink(state, signInLink){
        state.signInLink=signInLink
      },
      setAppUrl(state, appUrl){
        state.appUrl=appUrl
      },
      setUserProfileResponse(state, payload){
        state.userProfile=payload
      }
    },

    actions: {
      setShowRegistrationForm ({commit}, shouldShow) {
        commit('setShowRegistrationForm', shouldShow)
      },
      setShowCompletedForm ({commit}, shouldShow) {
        commit('setShowCompletedForm', shouldShow)
      },
      setPartyTypeCode ({commit}, payload) {
        commit('setPartyTypeCode', payload)
      },
      setLookupError ({commit}, payload) {
        commit('setLookupError', payload)
      },
      setValidateError ({commit}, payload) {
        commit('setValidateError', payload)
      },
      setProducerNum ({commit}, payload) {
        commit('setProducerNum', payload)
      },
      setDobOrTaxId ({commit}, payload) {
        commit('setDobOrTaxId', payload)
      },
      async validateProducer({commit, state}) {
        const checkProducerNumErr = (resp) => {
          if(resp.data) {
            commit('setProducerFirstName', resp.data.firstName);
            commit('setproducerLastName', resp.data.lastName);
            commit('setproducerEmail', resp.data.email);
            const err = resp.data.errorMessage
            if(err) {
              if(err.includes("producerNumber") || err.includes("Producer Number"))
                commit('setLookupError', err)
              else if (err.includes("dateOfBirth"))
                commit('setValidateError', "The Date of Birth entered does not match our records.")
              else if (err.includes("taxId"))
                commit('setValidateError', "The Tax ID entered does not match our records.")
              else commit('setValidateError', err)
            }
          }
        }

        let param = {
          "producerNumber": state.producerNum,
        }
        switch(state.partyTypeCode) {
          case 'I':
            if(!new RegExp(/(0\d{1}|1[0-2])\/([0-2]\d{1}|3[0-1])\/(19|20)\d{2}/).test(state.dobOrTaxId)){
              commit('setValidateError', 'Please enter your date of birth using the format MM/DD/YYYY.')
              return
            }
            param.dateOfBirth = state.dobOrTaxId;
            break;
          case 'C':
            if(!new RegExp(/\d{2}-\d{7}/).test(state.dobOrTaxId)){
              commit('setValidateError', 'Please enter Tax ID using the format ##-#######')
              return
            }
            param.taxId = state.dobOrTaxId; break;
        }
        try {
          const resp = await validateProducer(param)
          checkProducerNumErr(resp)
          return resp.data.valid
        }
        catch(err) {
          checkProducerNumErr(err.response)
          return false
        }
      },
      async lookupProducer({commit}, producerNum) {
        if(producerNum.length != 7 || !new RegExp(/^\d+$/).test(producerNum)){
          commit('setLookupError', 'Please enter your 7-digit numeric Production Number.')
          return
        }
        commit('setProducerNum', producerNum)
        try {
          const resp = await lookupProducer(producerNum);
          commit('setSignInLink', resp.data.loginUrl)
          if(resp.data.registrationStatus === "EXISTING_ACCOUNT") {
            commit('setLookupError', 'You currently have an existing account.  Please log in using the link below.  If you have any questions, please contact the Field Assistance Center between 7:00am and 5:30 pm at (800) 847-9785.')
            return
          }
          const partyTypeCode = resp.data.partyTypeCode
          if(partyTypeCode !== 'I' && partyTypeCode !== 'C') {
            commit('setLookupError', 'Unexpected partyTypeCode')
            return
          }
          commit('setPartyTypeCode', partyTypeCode)
          commit('setProducerFirstName', resp.data.firstName);
          commit('setproducerLastName', resp.data.lastName);
          commit('setproducerEmail', resp.data.email);
          commit('setregistrationStatus', resp.data.registrationStatus);
          commit('setLookupError', '')
        }
        catch(err) {
          if(err.response.data.errorCode==="INVALID_PRODUCER") {
            commit('setLookupError', 'This Production Number cannot be found.  If you have any questions, please contact the Field Assistance Center between 7:00 am and 5:30 pm at (800) 847-9785.')
          }
          else
            commit('setLookupError', err.response.data.errorMessage)
        }
      },
      async lookupUser({commit}, login) {
        try {
          const resp = await lookupUser(login);
          commit('setUserResponse', resp)
          return resp;
        }catch(error){
          return error.response
        }
      },
      async registerProducer({commit, dispatch}, data) {
        try{
          const resp = await registerProducer(data);
          commit('setResponse', resp.data);
          await dispatch('lookupSignUrl')
          return resp;
        }
        catch(error){
          commit('setResponse', error);
          return error
        }
      },
      async lookupSignUrl({commit}) {
        try {
          const resp = await lookupSignUrl();
          commit('setSignInLink', resp)
        }catch(error){
          return error.response
        }
      },
      async lookupAppUrl({commit}) {
        try {
          const resp = await lookupAppUrl();
          commit('setAppUrl', resp)
        }catch(error){
          return error.response
        }
      },
      async registerSecondProducer({commit, dispatch}, data) {
        try {
          const resp = await registerSecondProducer(data);
          commit('setSecondProducerResponse', resp.data);
          await dispatch('lookupSignUrl')
          return resp;
        } catch(error){
          commit('setSecondProducerResponse', error.response.data);
          return error.response;
        }
      },
     async lookupProducerNumber({commit}, producerNum) {
        try{
          const resp = await lookupProducer(producerNum);
          if(resp.data.registrationStatus != "EXISTING_ACCOUNT"){
            const partyTypeCode = resp.data.partyTypeCode
            commit('setPartyTypeCode', partyTypeCode)
          }
          return resp;
        } catch(error) {
          return error.response;
        }
      },
      async getUserOktaUserId({commit}) {
        try{
          const resp = await getUserOktaUserId();
          commit('setUserOktaUserResponse', resp.data);
          return resp;
        }
        catch(error){
          commit('setUserOktaUserResponse', error);
          return error
        }
      },
      async getUserProfile({commit}) {
        try{
          const resp = await getUserProfile();
          commit('setUserProfileResponse', resp.data);
          return resp;
        }
        catch(error){
          commit('setUserProfileResponse', error);
          return error
        }
      },
      async changePassword({commit, dispatch}, data) {
        try {
          const resp = await changePassword(data);
          commit('setResponse', resp.data);
          await dispatch('lookupSignUrl')
          return resp;
        } catch(error) {
          commit('setResponse', error);
          return error
        }
      },
      async addProducerAssistant({commit}, data) {
        try{
          const resp = await addProducerAssistant(data);
          commit('setProducerFirstName', resp.data.firstName);
          commit('setproducerLastName', resp.data.lastName);
          commit('setproducerEmail', resp.data.email);
          commit('setAddProducerAssistantResponse', resp);
          return resp;
        }
        catch(error){
          commit('setAddProducerAssistantResponse', error);
          return error
        }
      }
    }
  }
